import { Component, Prop, Vue } from 'vue-property-decorator'
import { genId } from '@/helpers/gen-id'

@Component
export default class DateInputCombo extends Vue {
	@Prop({ default: '', required: true }) value!: string
	pickerInputId = 'picker-' + genId()
	textInputId = 'input-' + genId()

	get date() {
		return this.value
	}

	set date(newValue) {
		this.$emit('input', newValue)
	}

	onCalendarContext(ctx) {
		if (ctx.selectedYMD) {
			this.date = ctx.selectedFormatted
			this.$emit('input', ctx.selectedFormatted)
		}
	}
}
